import type { MailboxInfo } from 'owa-client-types';
import type { CopilotSettingsStore, ImplementedCopilotFeatures } from 'owa-copilot-settings-store';
import createStoreCheckForGenericEnablement from './createStoreCheckForGenericEnablement';

const canUseBetaEndpoint: (
    scenario: ImplementedCopilotFeatures,
    mailboxInfo: MailboxInfo,
    skipLanguageCheck?: boolean,
    shouldIgnoreUserPreferences?: boolean
) => boolean | undefined =
    // eslint-disable-next-line owa-custom-rules/no-side-effects -- BASELINE, DO NOT COPY-PASTE
    createStoreCheckForGenericEnablement<ImplementedCopilotFeatures, boolean>(
        'BetaEndpoint',
        canUseBetaEndpointInternal
    );

export default canUseBetaEndpoint;

function canUseBetaEndpointInternal(
    _store: CopilotSettingsStore,
    _language: string,
    _scenario: ImplementedCopilotFeatures,
    _mailboxInfo: MailboxInfo
): boolean {
    return false;
}
